// Restore the original custom cursor behavior while keeping the smooth trailing.
(function () {
  const supportsCustomCursor = window.matchMedia(
    "(any-hover: hover) and (any-pointer: fine)"
  ).matches;
  if (!supportsCustomCursor) return;

  const cursor = document.querySelector(".cursor");
  const cursorInner = document.querySelector(".cursor2");
  if (!cursor || !cursorInner) return;

  document.documentElement.classList.add("has-custom-cursor");

  let mouseX = -100;
  let mouseY = -100;
  let outerX = -100;
  let outerY = -100;
  let isVisible = false;
  const lerpFactor = 0.15;

  function showCursor() {
    if (isVisible) return;
    isVisible = true;
    cursor.style.opacity = "1";
    cursorInner.style.opacity = "1";
  }

  function hideCursor() {
    if (!isVisible) return;
    isVisible = false;
    cursor.style.opacity = "0";
    cursorInner.style.opacity = "0";
  }

  function animate() {
    outerX += (mouseX - outerX) * lerpFactor;
    outerY += (mouseY - outerY) * lerpFactor;
    cursor.style.left = outerX + "px";
    cursor.style.top = outerY + "px";
    requestAnimationFrame(animate);
  }

  function handleMouseMove(e) {
    mouseX = e.clientX;
    mouseY = e.clientY;
    cursorInner.style.left = mouseX + "px";
    cursorInner.style.top = mouseY + "px";
    showCursor();
  }

  requestAnimationFrame(animate);

  document.addEventListener("mousemove", handleMouseMove, { passive: true });
  document.addEventListener("mouseenter", showCursor);
  document.addEventListener("mouseleave", hideCursor);

  window.addEventListener("mousedown", function () {
    cursor.classList.add("click");
  });
  window.addEventListener("mouseup", function () {
    cursor.classList.remove("click");
  });
  window.addEventListener("blur", hideCursor);

  document.addEventListener("visibilitychange", function () {
    if (document.hidden) {
      hideCursor();
    } else if (mouseX >= 0 && mouseY >= 0) {
      showCursor();
    }
  });

  const hoverTargets = document.querySelectorAll(
    "a, button, .cta-btn, .thumbnail"
  );
  hoverTargets.forEach(function (el) {
    el.addEventListener("mouseenter", function () {
      cursor.classList.add("hover");
    });
    el.addEventListener("mouseleave", function () {
      cursor.classList.remove("hover");
    });
  });
})();

(function () {
  const internalLinks = document.querySelectorAll(
    'a[href^="#"]:not([href="#"]):not([href="#!"])'
  );

  internalLinks.forEach(function (link) {
    link.addEventListener("click", function (e) {
      const hash = link.getAttribute("href");
      const target = document.querySelector(hash);
      if (!target) return;

      e.preventDefault();
      target.scrollIntoView({ behavior: "smooth", block: "start" });

      if (hash === "#top") {
        history.replaceState(
          null,
          "",
          window.location.pathname + window.location.search
        );
        return;
      }

      history.pushState(null, "", hash);
    });
  });
})();
